/************* NAME OF ROUTES ********************* */
/* -------------- AMBASSADOR ROUTES ----------------- */
// Login
export const NAVIGATE_TO_LOGINPAGE = '/login';
export const NAVIGATE_TO_FORGOTPASSWORDPAGE = '/forgot-password';

// Dashboard
export const NAVIGATE_TO_DASHBOARD = '/';

// School
export const NAVIGATE_TO_SCHOOLPAGE = '/schools';

// Item
export const NAVIGATE_TO_CANTEENITEMPAGE = '/item-page'
export const NAVIGATE_TO_CARDPAGE = '/card-page';
export const NAVIGATE_TO_CARDDETAILSPAGE = '/card-details';

// Student
export const NAVIGATE_TO_STUDENTPAGE = '/student-manage';
export const NAVIGATE_TO_STUDENTDETAILSPAGE = '/student-details'

// Parent
export const NAVIGATE_TO_PARENTPAGE = '/parent-manage';
export const NAVIGATE_TO_PARENTDETAILSPAGE = '/parent-details';

// Staff
export const NAVIGATE_TO_STAFFPAGE = '/staff-manage';
export const NAVIGATE_TO_STAFFDETAILSPAGE = '/staff-details';

// Operator
export const NAVIGATE_TO_OPERATORPAGE = '/operator-manage';
export const NAVIGATE_TO_OPERATORDETAILSPAGE = '/operator-details';

// Admin
export const NAVIGATE_TO_ADMINPAGE = '/admin-manage';
export const NAVIGATE_TO_ADMINDETAILSPAGE = '/admin-details';

// Session
export const NAVIGATE_TO_SESSIONPAGE = '/session';

// Transactions
export const NAVIGATE_TO_TRANSACTIONPAGE = '/transactions';

// Notification
export const NAVIGATE_TO_NOTIFICATIONPAGE = '/all-notifications';

// Profile
export const NAVIGATE_TO_PROFILEPAGE = '/profile';

// Support
export const NAVIGATE_TO_SUPPORTPAGE = '/support';
export const NAVIGATE_TO_INFOPAGE = '/info';

// Error Pages
export const ERROR_404_PAGE ='*'